import { isArray } from '@dimjs/lang';

export const getCheckChangeProps = (value, dataSource, multiple) => {
  if (value === undefined || value == null) {
    return undefined;
  }
  const values = isArray(value) ? value : [value];
  if (values.length === 0) {
    return undefined;
  }
  if (multiple) {
    const labelList = [] as string[];
    const valueList = [] as unknown[];
    values.forEach((value) => {
      const target = dataSource.find((item) => item.value === value);
      if (target) {
        labelList.push(target.label as string);
        valueList.push({ value: target.value, label: target.label });
      }
    });
    return {
      label: labelList.join('-'),
      value: valueList,
    };
  } else {
    const target = dataSource.find((item) => item.value === values[0]);
    if (target) {
      return {
        label: target.label,
        value: target.value,
      };
    }
  }
  return undefined;
};
